import { GameManager } from './types';

export function showBlurLayer(
  manager: GameManager,
  darken = false,
  hideOnClick = false,
  onHide: Function = null,
) {
  if (darken) {
    manager.DOM.blurLayer.style.backgroundColor = '#00000055';
  }
  manager.DOM.blurLayer.classList.add('blur-on');
  manager.DOM.blurLayer.style.display = '';

  if (hideOnClick) {
    manager.DOM.blurLayer.addEventListener('click', () => {
      if (onHide) onHide();
      hideBlurLayer(manager);
    });
  }
}

export function hideBlurLayer(manager: GameManager) {
  manager.DOM.blurLayer.style.backgroundColor = '';
  manager.DOM.blurLayer.classList.remove('blur-on');
  manager.DOM.blurLayer.style.display = 'none';
}
